import * as React from "react";
import * as ReactDOM from "react-dom";
import { Html } from "../../../../components";
import * as styles from "../../styles.scss";
import { tl } from "../../../../utils";

interface ITextProps {
  value: any;
}

export const Text = (props: ITextProps) => {
  if (props.value.content.length === 0) {
    return (
      <div>
        <span className={styles.answerTitleInline}>{tl('Не был дан ответ')}</span>
        <div>
          <b>{tl('Пропущен!')}</b>
        </div>
      </div>
    );
  }

  React.useEffect(() => {
    if (props.value.content.includes("<code")) {
      (window as any).initHighlightingCodeTag();
    }
  }, []);

  return (
    <div className={styles.answerBlock}>
      <span className={styles.answerTitleInline}>{tl('Ответ.')}</span>
      {props.value.answer_text_type === "richtext" ? (
        <div className="b-report__answer">
          <Html>{props.value.content}</Html>
        </div>
      ) : (
        <pre>
          <Html>{props.value.content}</Html>
        </pre>
      )}
    </div>
  );
};
